import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useActions, useSelector } from '~/hooks';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectAssistantRunId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const isLoading = useSelector(({ entityStates }) => entityStates.assistantRuns.loading);
  const itemsById = useSelector(({ workspaceResources }) => workspaceResources.assistantRuns.byId);

  const { listAssistantRuns } = useActions(({ assistantRunActions }) => ({
    listAssistantRuns: assistantRunActions.listAssistantRuns,
  }));

  const items = useMemo(
    () =>
      Object.values(itemsById).map((item) => ({
        label: item.runNo,
        value: item.id,
      })),
    [itemsById],
  );

  useEffect(() => {
    listAssistantRuns(pathParameters.assistant_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathParameters.assistant_id]);

  return (
    <ApiHelperSelectInput
      label={t('assistantRun.title')}
      items={items}
      onChange={(value) => setValue('assistant_run_id', value)}
      loading={isLoading}
      value={value}
      {...props}
    />
  );
};
